import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { EditActionContext } from "./EditActionContext";
import DeliveryNoteForm from "../../components/DeliveryNoteForm";

function useEditAction(index: any, formDefaultValues: any = {}, formWidgets: any = {}, deliveryNoteConfiguration: any = {}, showReceiverAccountSelector = true): any {
  const get = useGet();
  const getFunction = (id: number) => get(id, formDefaultValues);

  const onSuccessUpdate = () => {
    setShowModal(false);
    index();
  };

  const update = useUpdate();
  const updateFunction = () => update(onSuccessUpdate);

  const contextInstance = useContext(EditActionContext);
  const { setShowModal } = contextInstance;
  const { element } = contextInstance;

  const formRef = createRef<JSONSchemaForm>();

  const modalConfig = {
    title: "edit_delivery_note",
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(),
    size: "modal-xl",
    fullscreen: true as true,
  };

  const formConfig = {
    formRef: formRef,
    onSubmit: () => {
      updateFunction();
    },
    element: element,
    context: EditActionContext,
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <DeliveryNoteForm formConfig={formConfig} formWidgets={formWidgets} deliveryNoteConfiguration={deliveryNoteConfiguration} showReceiverAccountSelector={showReceiverAccountSelector}/>
    </CrudModuleFactoryModal>
  );

  return {
    getFunction,
    actionTemplate,
  };
}

export default useEditAction;
